import { compose } from 'redux'
import { connect } from 'react-redux'
import { withHandlers } from 'recompose'
import { getTireSizes, navigateToConfirmTireSize } from '../../actions'
import withLicencePlate from '../withLicencePlate'
import ShopByPlate from './ShopByPlate'

const withHandleVehicleSelect = withHandlers({
  handleVehicleSelect: ({ getTireSizes, navigateToConfirmTireSize }) => (...args) =>
    getTireSizes(...args)
      .then(navigateToConfirmTireSize)
})

const withHandleSubmit = withHandlers({
  handleSubmit: ({
    resetShopByPlateForm,
    getVehicleByPlateNumber,
    changeActiveTab,
    shopByTiresIndex,
    handleVehicleSelect,
    form
  }) => data =>
    getVehicleByPlateNumber(data, {
      onContinueClick: () => {
        resetShopByPlateForm(form)
        changeActiveTab(shopByTiresIndex)
      },
      onCancelClick: () => resetShopByPlateForm(form)
    }, handleVehicleSelect)
})

export default compose(
  withLicencePlate,
  connect(null, { getTireSizes, navigateToConfirmTireSize }),
  withHandleVehicleSelect,
  withHandleSubmit
)(ShopByPlate)

